import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import React from 'react';
import {sx} from './sx'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
    OnSelectPointsFromAndToCb
} from "@containers/singleVoyage/mutateVoyage/points/selectPointsFromAndTo/types/events";
import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";

interface IProps {
    point: IWayPointCreationWithCorrectionsSingleVoyage,
    nextPoint: IWayPointCreationWithCorrectionsSingleVoyage,
    index: number,
    onSelect: OnSelectPointsFromAndToCb,
}

const ItemSelectPointFromAndToMutateSingleVoyage = ({
                                                        point,
                                                        nextPoint,
                                                        onSelect,
                                                        index,
                                                    }: IProps) => {

    const handleClick = () => {
        onSelect({
            from: point,
            to: nextPoint,
            fromIndex: index,
            toIndex: index + 1
        })
    }

    return (
        <ButtonBase
            sx={sx.root}
            onClick={handleClick}
        >
            <Box sx={sx.stop}>
                <Box sx={sx.number}>{index + 1}</Box>
                <Box sx={sx.name} title={point.name}>{point.name}</Box>
            </Box>

            <ArrowForwardIcon sx={sx.arrow}/>

            <Box sx={sx.stop}>
                <Box sx={sx.number}>{index + 2}</Box>
                <Box sx={sx.name} title={nextPoint.name}>{nextPoint.name}</Box>
            </Box>

            <ChevronRightIcon className={'chevron'} sx={sx.chevron}/>
        </ButtonBase>
    );
};

export default ItemSelectPointFromAndToMutateSingleVoyage;
